export default __webpack_public_path__ + "static/communication-interface-9ee6cb85f3d89b13e6234e9ce1c143c1.png";